import script from "./RibbonTable.vue?vue&type=script&setup=true&lang=js"
export * from "./RibbonTable.vue?vue&type=script&setup=true&lang=js"

import "./RibbonTable.vue?vue&type=style&index=0&id=68317ca8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68317ca8"]])

export default __exports__